import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController, NavController, ToastController } from '@ionic/angular';
import { UtilService } from '../../service/util.service';
import { UserData } from '../../providers/user-data';
import { NavigationExtras, Router } from '@angular/router';
import { ProductRequestService } from '../product-request/product-request.service';
import { RoleAccess } from '../../models/role-access.model';
import { ProductRequestStatus } from '../../enum/ProductRequestStatus';
import { UserProfile } from '../../models/user-profile.model';
import { Storage } from '@ionic/storage';
import { AES } from 'crypto-js';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-po-auto-approval',
  templateUrl: './po-auto-approval.page.html',
  styleUrls: ['./po-auto-approval.page.scss'],
})
export class PoAutoApprovalPage implements OnInit {

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };

  rows: any;
  productRequestList: any;
  filteredData: any;
  token: any;
  userProfile: UserProfile= new UserProfile();
  counterId: any;
  statusId: any;
  counterList: any[] = [];
  docDateStart: any;
  docDateEnd: any;

  requestStatus = ProductRequestStatus;
  requestStatusList = Object.keys(ProductRequestStatus).filter(
    requestStatus => typeof this.requestStatus[requestStatus] === 'number'
  );

  keywordSearch: any;
  
  userAccess: any[] = [];
  roleAccess = new RoleAccess();
  roleName: any;

  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private userData: UserData,
    private modalController: ModalController,
    private router: Router,
    private requestService: ProductRequestService,
    private alertController: AlertController
  ) { }

  ngOnInit() {
  }
  
  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.getDataForAdvancedFilter();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  getDataForAdvancedFilter() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list,
      };

      this.requestService.getDataforAdvancedFilter(options)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        this.counterList = response.results.counter_data;

        this.pageCallback({ offset: this.page.offset });
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        this.pageCallback({ offset: this.page.offset });
      });
    });
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let counterIds: any;
      if(this.counterId) { counterIds = this.counterId; }
      else { counterIds = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list; }

      let options = {
        "token": this.token,
        "page": offset.toString(),
        "counter_id": counterIds,
        "doc_date_start": this.docDateStart ? this.docDateStart : '2000-01-01',
        "doc_date_end": this.docDateEnd ? this.docDateEnd : '4712-12-31',
        "status_id": this.statusId !== undefined ? this.statusId : 'null',
        "keywords": this.keywordSearch ? this.keywordSearch : 'null',
        "username":this.userProfile.username
      };
      this.requestService.getPOforApprove(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.productRequestList = response.results.data;
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }

  checkStatus(status: any) {
    let cssClass: any = '';
    if(status === '0') { cssClass = 'status pending'}
    if(status === '1') { cssClass = 'status sent'}
    if(status === '2') { cssClass = 'status void'}
    if(status === '3') { cssClass = 'status void'}
    if(status === '4') { cssClass = 'status pending'}
    if(status === '5') { cssClass = 'status pending'}
    if(status === '6') { cssClass = 'status sent'}
    if(status === '7') { cssClass = 'status sent'}
    return cssClass;
  }
  
  goToUpdatePage(id: any,actionType:any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptAction = AES.encrypt(JSON.stringify(actionType),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptAction
      }
    };
    this.navCtrl.navigateForward(['/product-request/product-request-detail'], navigationExtras);
  }
}
